import React from "react";
//#region types
import {DocumentDraftTypeProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { useDocumentDraftService } from "serviceHooks";
//#endregion

const DocumentDraftTypeTag: React.FC<DocumentDraftTypeProps> = ({ type }) => {
  const documentDraftService = useDocumentDraftService();

  return <>{documentDraftService.getTypeText(type)}</>;
};

export default DocumentDraftTypeTag;
